// todo: 
// render the list of tag
// click of each tag, and active tag
// on click, call the callback method with the active tab id
// Keep ADA in mind

import React, { useState } from 'react';
import './tabs.css'; // Import your CSS file

const Tabs = ({ tabs = [], tabSelect, openInPopup = false }) => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabClick = (index) => {
    setActiveTab(index);
    tabSelect(tabs[index].categoryId)
  };

  return (
    <div className="tabs-container">
      <ul className={openInPopup === false ? "tab-list show-tab-list-horizontal" : "tab-list"}>
        {tabs.map((tab, index) => (
          <li
            key={tab.categoryId}
            className={`tab-item ${index === activeTab ? 'active' : ''}`}
            onClick={() => handleTabClick(index)}
          >
            {tab.category}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Tabs;